import styled from 'styled-components';
import {colors} from '../../../utils/styled/_variables.styled';
import { defaultLink } from "../../../utils/styled/_mixins.style";

export const InfiosCheckboxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 8px;
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

  p{
		font-size:19px;
	}

  a {
  	font-size:19px;
    display: inline;
    font-weight: 300;
    text-decoration: underline;
    ${defaultLink};
  }

  &:before {
    content: "";
    border: 1px solid ${props => props.disabled ? colors.gray1 : colors.infiosGray};
    background: ${props => props.disabled ? colors.gray1 : colors.white};
    width: 100%;
    height: 100%;
    max-height: 24px;
    max-width: 24px;
    position: absolute;
    top: 0;
    box-sizing: border-box;
    pointer-events: none;
    z-index: 0;
  }

  &:hover {
    &:before {
      border: 2px solid ${colors.infiosGray};
    }
  }

  label {
    margin: 0 0 0 36px;
  }
`;

export const InfiosCheckboxFill = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  top: 0;
  left: 0;
  background: ${colors.infiosGray};
  pointer-events: none;
  z-index: 1;

  &:before {
    content: '';
    position: absolute;
    opacity: 0;
    width: 24px;
    height: 24px;
  }
`;

export const InfiosCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  z-index: 2;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:checked {
    & ~ ${InfiosCheckboxFill} {
      width: 24px;
      height: 24px;

      &:before {
        opacity: 1;
      }

      &:after {
        content: "";
        position: absolute;
        width: 7px;
        height: 11px;
        border-bottom: 2px solid ${colors.white};
        border-right: 2px solid ${colors.white};
        transform: rotate(45deg);
        top: 5px;
        left: 8px;
      }
    }
  }
`;
